import React from 'react';

import { Badge, Subtitle, Title } from './styles';

interface AuthFormHeaderProps {
  badge: string;
  title: string;
  subtitle: string;
}

const AuthFormHeader: React.FC<AuthFormHeaderProps> = ({
  badge,
  title,
  subtitle,
}) => {
  return (
    <>
      <Badge>
        <span className="dot" />
        <span className="label">{badge}</span>
      </Badge>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </>
  );
};

export { AuthFormHeader };
